// ----------------------------------------------------------------------------
// Аутентификация
// ----------------------------------------------------------------------------

const ttAuthTime = 700;

const ttAuth = (event) => {
    if (event) {
        event.preventDefault();
    }

    window.v_ttAuth_scrollTop = window.scrollY;
    document.cookie = "v_ttAuth_scrollTop=" + encodeURIComponent(window.v_ttAuth_scrollTop) + "; path=/; domain=" + document.domain.replace('guides.', '') + "; max-age=" + ttAuthTime;
    document.cookie = "v_ttAuth_Exec=" + encodeURIComponent(window.v_ttAuth_Exec) + "; path=/; domain=" + document.domain.replace('guides.', '') + "; max-age=" + ttAuthTime;
    document.cookie = "v_ttAuth_URL=" + encodeURIComponent(window.window.location) + "; path=/; domain=" + document.domain.replace('guides.', '') + "; max-age=" + ttAuthTime;
    window.location = '//' + document.domain.replace('guides.', '') + '/myaccount/';

    return false;
}

export default ttAuth;

